import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { NO_COLLABORATOR_MESSAGE } from '../vacationReceipts.definitions';

export const NoCollaboratorNotice: React.FC = () => (
    <div className="flex gap-2 rounded-md border-l-4 border-yellow-400 bg-yellow-50 p-4">
        <InformationCircleIcon className="h-5 w-5 shrink-0 text-yellow-500" aria-hidden="true" />
        <p className="text-sm text-yellow-800">{NO_COLLABORATOR_MESSAGE}</p>
    </div>
);

export default NoCollaboratorNotice;
